<template>
<b-container class="user-add-container">
	<b-row>
		<b-col>
			<p><strong>You do not have access to this area.</strong></p>
			<b-button type="button" variant="primary" @click="goToHome()">Home</b-button>
		</b-col>
	</b-row>
</b-container>
</template>
<script>

import Vue from 'vue';

export default {
  name: 'NoAccess',
  components: {
  },
  data() {
	return {
	}
	},
	mounted() {
   },
  methods: {
  	goToHome() {
  		this.$router.push('/')
  	},
	}, // end of methods();
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			Vue.prototype.$bus.$emit("map:toggle", 0);
		});
	},
}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>